import type { IspSportsAlias } from '@ps/web-core-store';

import { configuredLandingPageEventTypeIds } from './pages/config';
import { EventTypeId } from './types/eventType';

const id = '\\d+'; // https://github.com/pillarjs/path-to-regexp#custom-matching-parameters

const competitionId = `:competitionId(${id})`;
const eventId = `:eventId(${id})`;
const eventTypeId = `:eventTypeId(${id})`;
const landingPageEventTypeId = `:eventTypeId(${configuredLandingPageEventTypeIds.join('|')})`;
const marketId = `:marketId(\\d{3}-\\d+)`;
const meetingId = `:meetingId(${id})`;
const promoId = ':promoId(pss[\\w-]+)';
const raceId = `:raceId(${id})`;
const tennisEventTypeId = `:eventTypeId(${EventTypeId.TENNIS})`;
const animalRacingEventTypeId = `:eventTypeId(${EventTypeId.HORSE_RACING}|${EventTypeId.GREYHOUND_RACING})`;

// TODO - These currently cause some widgets to error so using the hard coded
// version for now which is in-line with current implementation
// const golfId = `:eventTypeId(${EventTypeId.GOLF})`;

const golfId = EventTypeId.GOLF;

export const sportsRoutes = {
  sportsAnimalRacingFuture: `/sports/:eventTypeSlug/${animalRacingEventTypeId}/future/`,
  sportsAnimalRacingFutureMarket: `/sports/:eventTypeSlug/${animalRacingEventTypeId}/future/:eventSlug/${marketId}/`,
  sportsAnimalRacingMeetings: `/sports/:eventTypeSlug/${animalRacingEventTypeId}/meetings/`,
  sportsAnimalRacingNext: `/sports/:eventTypeSlug/${animalRacingEventTypeId}/`,
  sportsAnimalRacingRace: `/sports/:eventTypeSlug/${animalRacingEventTypeId}/:venueSlug/${meetingId}/${raceId}/`,
  sportsAnimalRacingSpecials: `/sports/:eventTypeSlug/${animalRacingEventTypeId}/specials/`,
  sportsCompetition: `/sports/:eventTypeSlug/${eventTypeId}/:competitionSlug/${competitionId}/`,
  sportsCompetitionOutrights: `/sports/:eventTypeSlug/${eventTypeId}/:competitionSlug/${competitionId}/outrights/`,
  sportsCompetitions: `/sports/:eventTypeSlug/${landingPageEventTypeId}/competitions/`,
  sportsEmbeddedHistoricalBets: '/sports/_/historical-my-bets/:status?/',
  sportsEmbeddedMyBets: '/sports/_/my-bets/:status?/',
  sportsEmbeddedSettings: '/sports/_/settings/',
  sportsEvent: `/sports/:eventTypeSlug/${eventTypeId}/:competitionSlug/${competitionId}/:eventSlug/${eventId}/`,
  sportsGolfCompetitions: `/sports/:eventTypeSlug/${golfId}/:competitionSlug/${competitionId}/`,
  sportsGolfMatches: `/sports/:eventTypeSlug/${golfId}/:competitionSlug/${competitionId}/matches/`,
  sportsHistoricalBets: '/sports/historical-my-bets/:status?/',
  sportsHome: '/sports/',
  sportsInPlay: '/sports/in-play/',
  sportsInPlaySport: `/sports/in-play/:eventTypeSlug/${eventTypeId}/`,
  sportsLanding: `/sports/:eventTypeSlug/${landingPageEventTypeId}/`,
  sportsMatchFiltering: `/sports/:eventTypeSlug/${eventTypeId}/matches/`,
  sportsMyBets: '/sports/my-bets/:status?/',
  sportsPromotion: `/sports/promotions/${promoId}/`,
  sportsPromotions: '/sports/promotions/',
  sportsSelfExcluded: '/sports/self-excluded/',
  sportsSelfExcludedHistoricalBets: '/sports/self-excluded/historical-my-bets/:status?/',
  sportsSelfExcludedMyBets: '/sports/self-excluded/my-bets/:status?/',
  sportsSettings: '/sports/settings/',
  sportsSpecials: `/sports/:eventTypeSlug/${eventTypeId}/specials/`,
  sportsSport: `/sports/:eventTypeSlug/${eventTypeId}/`,
  sportsSportInPlay: `/sports/:eventTypeSlug/${eventTypeId}/in-play/`,
  sportsTennisCompetition: `/sports/:eventTypeSlug/${tennisEventTypeId}/:competitionSlug/${competitionId}/`
} as const satisfies Record<IspSportsAlias, '/sports/' | `/sports/${string}/`>;
